import ShareIcon from "@mui/icons-material/Share";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { GridColumns } from "@mui/x-data-grid";
import { DialogTitle, Toolbar, useDialog } from "common";
import I18n from "i18n-js";
import { useMemo } from "react";
import { PERMISSIONS } from "../../app/constants";
import DataCard from "../../components/DataCard/DataCard";
import { CardSettings } from "../../components/DataCard/useDataCard";
import useAccess from "../profile/useAccess";
import { SharingListItem } from "./sharingApi";
import SharingForm from "./SharingForm";
import SharingTools from "./SharingTools";
import useSharingList from "./useSharingList";

export default function SharingList({
  waiver_id,
  showhHeader,
}: {
  waiver_id?: any;
  showhHeader?: boolean;
}) {
  const grid = useSharingList({ waiver_id });
  const access = useAccess();
  const [itemToShare, setItemToShare, itemToShareDialog] =
    useDialog<SharingListItem>();
  const cardSettings: CardSettings = useMemo(() => {
    return {
      header: {
        titleField: "name",
      },
      groupKey: "location_id",
      renderGroupHeader: (groupValue, rows) => (
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ m: 2 }}>
            {rows[0].location_label} ({rows.length})
          </Typography>
        </Box>
      ),
    };
  }, []);
  const columns: GridColumns = [
    { field: "name", flex: 1 },
    { field: "location_label", flex: 1 },
    { field: "token", flex: 1 },
    {
      field: "sharing_waivers",
      valueFormatter: ({ value }: any) => {
        return value?.map((v: any) => v.name).join(", ");
      },
    },
    {
      field: "tags",
      valueFormatter: ({ value }: any) => {
        return value?.join(", ");
      },
    },
  ];

  return (
    <>
      <DataCard
        headerTitle={
          <Toolbar sx={{ gap: 2 }}>
            <ShareIcon />
            <Typography variant="h5">{I18n.t("Sharing.title")}</Typography>
          </Toolbar>
        }
        {...grid}
        showPagination={false}
        headerItems={["search", "refresh"]}
        canCreate={access.hasPermissions(PERMISSIONS.MANAGE_SHARINGS)}
        canDelete={access.hasPermissions(PERMISSIONS.MANAGE_SHARINGS)}
        canEdit={access.hasPermissions(PERMISSIONS.MANAGE_SHARINGS)}
        renderModalForm={props => (
          <SharingForm
            disabled={!access.hasPermissions(PERMISSIONS.MANAGE_SHARINGS)}
            {...props}
            defaultValues={waiver_id ? { waiver_ids: [waiver_id] } : undefined}
          />
        )}
        cardSettings={cardSettings}
        columns={columns}
        cardActions={params => [
          <IconButton
            title={I18n.t("Sharing.share")}
            onClick={() => setItemToShare(params.row)}
          >
            <ShareIcon />
          </IconButton>,
        ]}
      />
      <Dialog {...itemToShareDialog} maxWidth="lg" fullWidth>
        <DialogTitle onClose={itemToShareDialog.onClose}>Share</DialogTitle>
        <DialogContent>
          <SharingTools
            sharing={itemToShare as any}
            onClose={itemToShareDialog.onClose}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
